// extracted by mini-css-extract-plugin
export var slide = "Slide-module--slide--9415d";
export var picture = "Slide-module--picture--13d94";
export var img = "Slide-module--img--64af3";
export var title = "Slide-module--title--22c2b";
export var description = "Slide-module--description--16436";
export var content = "Slide-module--content--0193b";